import React from 'react';
import { motion } from 'framer-motion';
import { Wind, Activity, Droplets } from 'lucide-react';
import { useAirQuality } from '../hooks/useAirQuality';

const AirQualityCard: React.FC = () => {
  const { data, loading, getAqiLabel, getAqiColor } = useAirQuality();

  if (loading) {
    return (
      <div className="bg-gray-900/50 backdrop-blur-xl border border-cyan-500/30 rounded-xl p-4">
        <div className="animate-pulse flex items-center gap-2">
          <Wind className="text-cyan-500" />
          <span className="text-gray-400">Loading air quality...</span>
        </div>
      </div>
    );
  }

  if (!data) return null;

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="bg-gray-900/50 backdrop-blur-xl border border-cyan-500/30 rounded-xl p-4"
    >
      <div className="flex items-center gap-2 mb-3">
        <Wind className="text-cyan-500" />
        <h3 className="font-bold">Air Quality</h3>
      </div>

      <div className="flex items-center justify-between mb-3">
        <div>
          <div className="text-3xl font-bold" style={{ color: getAqiColor(data.aqi) }}>
            {getAqiLabel(data.aqi)}
          </div>
          <div className="text-xs text-gray-400">AQI: {data.aqi}</div>
        </div>
        <div className="text-right">
          <div className="text-sm">PM2.5: {data.components.pm2_5.toFixed(1)}</div>
          <div className="text-sm">PM10: {data.components.pm10.toFixed(1)}</div>
        </div>
      </div>

      <div className="grid grid-cols-4 gap-1 text-xs">
        <div className="text-center">
          <div className="text-cyan-500">CO</div>
          <div>{data.components.co.toFixed(1)}</div>
        </div>
        <div className="text-center">
          <div className="text-cyan-500">NO2</div>
          <div>{data.components.no2.toFixed(1)}</div>
        </div>
        <div className="text-center">
          <div className="text-cyan-500">O3</div>
          <div>{data.components.o3.toFixed(1)}</div>
        </div>
        <div className="text-center">
          <div className="text-cyan-500">SO2</div>
          <div>{data.components.so2.toFixed(1)}</div>
        </div>
      </div>
    </motion.div>
  );
};

export default AirQualityCard;